import { queryClient } from '@api/queryClient';
import ProfileService from './service';
import {
  GetUserProfileResponse,
  SaveUserProfileRequest,
  SaveUserProfileResponse,
  UpdateUserProfileRequest,
  UpdateUserProfileResponse,
} from './types';
import { ResponseStatuses } from '@src/utils/enums';

export const PROFILE_QUERY_KEYS = {
  GET_PROFILE: 'getProfile',
};

export class ProfileMutations {
  public static readonly getUserProfile = async (): Promise<GetUserProfileResponse> => {
    const response = await ProfileService.getUserProfile();
    return response;
  };

  public static readonly saveUserProfile = async (
    payload: SaveUserProfileRequest
  ): Promise<SaveUserProfileResponse> => {
    const response = await ProfileService.saveUserProfile(payload);

    if (response.status === ResponseStatuses.Success) {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEYS.GET_PROFILE] });
      return response;
    } else {
      return Promise.reject(response.msg || 'User profile creation failed');
    }
  };

  public static readonly updateUserProfile = async (
    payload: UpdateUserProfileRequest
  ): Promise<UpdateUserProfileResponse> => {
    const response = await ProfileService.updateUserProfile(payload);

    if (response.status === ResponseStatuses.Success) {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEYS.GET_PROFILE] });
      return response;
    } else {
      return Promise.reject(response.msg || 'User profile update failed');
    }
  };
}
